import * as Comlink from 'comlink'

export const workerFetch = async (url: string, options?: object) => {
  const worker = new Worker('/workers/api.worker.js')
  const obj = Comlink.wrap(worker) as any

  const [json, error] = await obj.fetch(url, options)
  return [json, error]
}
